export function sendContact({ email, body, type }) {
  if (!type) type = "message"
  return this.post(`/api/contact/`, { type, body, email })
}
